import {
  GetDepartamentoByFiltersParamsProps,
  getDepartamentoByFilters,
} from "api/Departamento.service"
import {
  GetUsuarioByFiltersParamsProps,
  getUsuarioByFilters,
} from "api/Usuario.service"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useCallback } from "react"
import departamentosTableAdapter from "./components/TableDepartamentos/DepartamentosTable.adapter"
import usuariosTableAdapter from "./components/TableUsuarios/UsuariosTable.adapter"
import DepartamentosView from "./views/Departamentos"
import UsuariosView from "./views/Usuarios"

const RoleManagement = () => {
  const fetchDepartamentos = useCallback(
    () => (queryParams: GetDepartamentoByFiltersParamsProps) =>
      getDepartamentoByFilters({
        ...queryParams,
        SortingCriteria: queryParams.SortingCriteria,
      }),
    []
  )

  const {
    items: departamentos,
    isLoading: departamentosIsLoading,
    totalCount: departamentosTotalCount,
    setServiceQuery: setDepartamentosServiceQuery,
    fetchTableData: fetchDepartamentosTableData,
  } = useFilterMenu({
    serviceCall: fetchDepartamentos,
    serviceAdapter: departamentosTableAdapter,
  })
  const fetchUsuarios = useCallback(
    () => (queryParams: GetUsuarioByFiltersParamsProps) =>
      getUsuarioByFilters({
        ...queryParams,
        SortingCriteria: queryParams.SortingCriteria,
      }),
    []
  )

  const {
    items: usuarios,
    isLoading: usuariosIsLoading,
    totalCount: usuariosTotalCount,
    setServiceQuery: setUsuariosServiceQuery,
    fetchTableData: fetchUsuariosTableData,
  } = useFilterMenu({
    serviceCall: fetchUsuarios,
    serviceAdapter: usuariosTableAdapter,
  })

  return (
    <section className='tw-bg-white !tw-h-full tw-overflow-hidden'>
      <DepartamentosView
        items={departamentos}
        isLoading={departamentosIsLoading}
        totalCount={departamentosTotalCount}
        setServiceQuery={setDepartamentosServiceQuery}
        fetchTableData={() => {
          fetchUsuariosTableData()
          return fetchDepartamentosTableData()
        }}
      />

      <UsuariosView
        items={usuarios}
        isLoading={usuariosIsLoading}
        totalCount={usuariosTotalCount}
        setServiceQuery={setUsuariosServiceQuery}
        fetchTableData={() => {
          fetchDepartamentosTableData()
          return fetchUsuariosTableData()
        }}
      />
    </section>
  )
}

export default RoleManagement
